import FormWrapper from './index.style';

export default FormWrapper;
